import { AfterViewInit, Component, ElementRef } from '@angular/core';

@Component({
  selector: 'ws-site-contact',
  templateUrl: './contact.component.html'
})
export class SiteContactComponent implements AfterViewInit {
  constructor(private host: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    const form = this.host.nativeElement.querySelector<HTMLFormElement>('#contact-form');
    if (!form) { return; }
    form.addEventListener('submit', e => {
      e.preventDefault();
      const note = this.host.nativeElement.querySelector<HTMLElement>('#form-note');
      if (note) {
        note.textContent = 'Thanks — this is a design preview, so submissions aren\'t sent yet. Connect this form to your backend before launch.';
        note.style.display = 'block';
      }
    });
  }
}
